import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  border: 1px solid #282828;
  padding: 8px 10px;
  border-radius: 5px;
  ${props => props.width && `width: ${props.width};`}

  input {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    border: none;
    flex-grow: 1;
  }
`;
